import { gql } from '@apollo/client';

export default gql`
  query configurations($confirmationNum: String) {
    configurations(confirmationNum: $confirmationNum) {
      id
      model
      modelCode
      edition
      editionCode
      confirmationNum
      configuratorRefURL
      configuratorOptions {
        category
        name
        type
        option
        code
      }
      createdAt
      version
      vehicleConfigurationAssets {
        version
        locale
        title
        expectAvailableDate
        exterior {
          color {
            categoryCode
            categoryName
            configuredOption {
              code
              title
              tileImage
              images
            }
            features {
              id
              title
              description
            }
          }
        }
        wheel {
          categoryCode
          categoryName
          configuredOption {
            code
            title
            tileImage
            images
          }
          features {
            id
            title
            description
          }
        }
        interior {
          color {
            categoryCode
            categoryName
            configuredOption {
              code
              title
              tileImage
              images
            }
            features {
              id
              title
              description
            }
          }
        }
      }
    }
  }
`;
